import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e249d1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "UploadedFiles"
}
const _hoisted_2 = {
  key: 0,
  class: "UploadedFiles__title"
}
const _hoisted_3 = {
  key: 1,
  class: "UploadedFiles__holder"
}
const _hoisted_4 = {
  key: 0,
  class: "UploadedFiles__title"
}
const _hoisted_5 = { class: "UploadedFiles__item" }
const _hoisted_6 = { class: "item__actions" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download item__download" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times item__delete" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        (_ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `uploaded-file-${idx}`
                }, [
                  (file.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(file.title), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(file.original_name || 'Файл без имени') + " ", 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("a", {
                        href: file.path,
                        target: "_blank",
                        download: ""
                      }, [
                        _createVNode(_component_the_button, {
                          class: "extra-small primary",
                          hint: "Скачать файл"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_7),
                      (!_ctx.noDelete)
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 0,
                            class: "extra-small red ml-2",
                            hint: "Удалить файл",
                            disabled: _ctx.loading,
                            loading: _ctx.loading,
                            onClick: ($event: any) => (_ctx.deleteFile(file.id, idx))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 2
                          }, 1032, ["disabled", "loading", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}